import { ApiError } from "@softmax/observatory-client/transport";
import type { Entry } from "../../desk-records";
import { normaliseEntry } from "../../entry/pitch-entry";
import { maxConcurrentReads, mapLimit } from "./parallel-reads";

export async function readPitchEntries({
  get,
  policyVersionIds,
}: {
  get: <T>(path: string) => Promise<T>;
  policyVersionIds: string[];
}): Promise<Record<string, Entry | null>> {
  const entries = await mapLimit({
    items: [...new Set(policyVersionIds)],
    limit: maxConcurrentReads,
    fn: async (id) => {
      const raw = await get<unknown>(
        `/v2/policy-files/${encodeURIComponent(id)}/entry/entry.json`,
      ).catch((error: unknown) => {
        if (error instanceof ApiError && error.status === 404) return null;

        throw error;
      });
      return [id, normaliseEntry(raw)] as const;
    },
  });
  return Object.fromEntries(entries);
}
